module.exports = "/_next/static/images/TankerL-2d7fb3875c5e6a61fafaac5dab622ba1.png";